import dreamStreet from "../../../../assets/story/chapters/chapter-01/backgrounds/dream-looping-street-dialogue-v1.png?url";
import chapterOneField from "../../../../assets/story/chapters/chapter-01/backgrounds/field-looping-street-v2.png?url";
import morningBedroom from "../../../../assets/story/chapters/chapter-01/backgrounds/man-bedroom-morning-v1.png?url";
import backstage from "../../../../assets/story/chapters/chapter-01/backgrounds/theatre-backstage-v1.png?url";
import ballReturnStill from "../../../../assets/story/chapters/chapter-01/stills/ball-return-v1.png?url";
import loopingWalkStill from "../../../../assets/story/chapters/chapter-01/stills/looping-walk-v1.png?url";
import morningStill from "../../../../assets/story/chapters/chapter-01/stills/morning-v1.png?url";
import walkingHomeStill from "../../../../assets/story/chapters/chapter-01/stills/walking-home-v1.png?url";
import dog from "../../../../assets/story/chapters/chapter-01/characters/dog-dream-standing-v1.png?url";
import flint from "../../../../assets/story/chapters/chapter-01/characters/flint-standing-v1.png?url";
import manager from "../../../../assets/story/chapters/chapter-01/characters/compass-standing-v1.png?url";
import man from "../../../../assets/story/chapters/chapter-01/characters/man-dream-standing-v1.png?url";
import nightEyes from "../../../../assets/story/backgrounds/night-eyes-gallery-v1.png?url";
import theater from "../../../../assets/story/backgrounds/dream-theater-dialogue-v2.png?url";
import protagonist from "../../../../assets/story/characters/protagonist-hourglass-standing-v1.png?url";
import ewer from "../../../../assets/story/characters/ewer-standing-v1.png?url";
import frame from "../../../../assets/story/characters/frame-standing-v1.png?url";
import pin from "../../../../assets/story/characters/pin-standing-v1.png?url";
import projector from "../../../../assets/story/characters/projector-standing-v1.png?url";
import chapterTwoBoy from "../../../../assets/story/characters/chapter-02-boy-v2.png?url";
import chapterTwoGirl from "../../../../assets/story/characters/chapter-02-girl-v2.png?url";
import projectionRoom from "../../../../assets/story/backgrounds/projection-room-v1.png?url";
import hospitalRoom from "../../../../assets/story/backgrounds/hospital-room-v1.png?url";
import selectionTable from "../../../../assets/story/backgrounds/theatre-selection-table-v1.png?url";
import outerWindow from "../../../../assets/story/backgrounds/outer-window-v1.png?url";

import chapterTwoMountain from "../../../../assets/story/chapters/chapter-02/backgrounds/mountain-route-v1.png?url";
import chapterTwoSummit from "../../../../assets/story/chapters/chapter-02/backgrounds/dragon-summit-v1.png?url";
import chapterTwoFlight from "../../../../assets/story/chapters/chapter-02/backgrounds/dragon-flight-v1.png?url";
import chapterTwoMorning from "../../../../assets/story/chapters/chapter-02/backgrounds/morning-excursion-v1.png?url";

import chapterThreeChild from "../../../../assets/story/chapters/chapter-03/characters/child-standing-v1.png?url";
import chapterThreeSanta from "../../../../assets/story/chapters/chapter-03/characters/santa-standing-v1.png?url";
import chapterThreeCorridor from "../../../../assets/story/chapters/chapter-03/backgrounds/endless-corridor-v1.png?url";
import chapterThreeField from "../../../../assets/story/chapters/chapter-03/backgrounds/field-snowy-house-v1.png?url";
import chapterThreeFireplace from "../../../../assets/story/chapters/chapter-03/backgrounds/fireplace-v1.png?url";
import chapterThreeMorningRoom from "../../../../assets/story/chapters/chapter-03/backgrounds/living-morning-v1.png?url";
import chapterThreeNightmare from "../../../../assets/story/chapters/chapter-03/stills/projection-nightmare-v1.png?url";
import chapterThreeCocoa from "../../../../assets/story/chapters/chapter-03/stills/cocoa-v1.png?url";
import chapterThreeMorning from "../../../../assets/story/chapters/chapter-03/stills/morning-v1.png?url";

import chapterFourFriend from "../../../../assets/story/chapters/chapter-04/characters/friend-winter-standing-v1.png?url";
import chapterFourMemoryHeroine from "../../../../assets/story/chapters/chapter-04/characters/memory-heroine-winter-standing-v1.png?url";
import chapterFourField from "../../../../assets/story/chapters/chapter-04/backgrounds/field-winter-piano-v1.png?url";
import chapterFourCafe from "../../../../assets/story/chapters/chapter-04/backgrounds/cafe-endless-dusk-v1.png?url";
import chapterFourPiano from "../../../../assets/story/chapters/chapter-04/stills/piano-and-bench-v1.png?url";
import chapterFourAfternoon from "../../../../assets/story/chapters/chapter-04/stills/empty-afternoon-v1.png?url";
import chapterFourRealizes from "../../../../assets/story/chapters/chapter-04/stills/frame-realizes-v1.png?url";
import chapterFourHospital from "../../../../assets/story/chapters/chapter-04/stills/hospital-wake-v1.png?url";

import chapterFiveOwner from "../../../../assets/story/chapters/chapter-05/characters/owner-standing-v1.png?url";
import chapterFiveRobot from "../../../../assets/story/chapters/chapter-05/characters/robot-standing-v1.png?url";
import chapterFiveField from "../../../../assets/story/chapters/chapter-05/backgrounds/field-layered-study-v1.png?url";
import chapterFiveDining from "../../../../assets/story/chapters/chapter-05/backgrounds/dining-morning-v1.png?url";
import chapterFiveStain from "../../../../assets/story/chapters/chapter-05/stills/stain-v1.png?url";
import chapterFiveLayered from "../../../../assets/story/chapters/chapter-05/stills/layered-room-v1.png?url";
import chapterFiveCups from "../../../../assets/story/chapters/chapter-05/stills/two-cups-v1.png?url";
import chapterFiveMorning from "../../../../assets/story/chapters/chapter-05/stills/morning-v1.png?url";

import chapterSixMusicRoom from "../../../../assets/story/chapters/chapter-06/backgrounds/music-room-v1.png?url";
import chapterSixRainyRoom from "../../../../assets/story/chapters/chapter-06/backgrounds/rainy-bedroom-v1.png?url";
import chapterSixField from "../../../../assets/story/chapters/chapter-06/backgrounds/field-contest-hall-v1.png?url";
import chapterSixPianoMorning from "../../../../assets/story/chapters/chapter-06/backgrounds/piano-morning-v1.png?url";
import chapterSixWhatHappened from "../../../../assets/story/chapters/chapter-06/stills/what-happened-v1.png?url";
import chapterSixFreeze from "../../../../assets/story/chapters/chapter-06/stills/contest-freeze-v1.png?url";
import chapterSixFall from "../../../../assets/story/chapters/chapter-06/stills/fall-into-window-v1.png?url";
import chapterSixWaiting from "../../../../assets/story/chapters/chapter-06/stills/waiting-v1.png?url";
import chapterSixRescue from "../../../../assets/story/chapters/chapter-06/stills/rescue-v1.png?url";
import chapterSixSeventhNote from "../../../../assets/story/chapters/chapter-06/stills/seventh-note-v1.png?url";
import chapterSixBackstage from "../../../../assets/story/chapters/chapter-06/stills/wet-backstage-v1.png?url";
import chapterSixFriendMorning from "../../../../assets/story/chapters/chapter-06/stills/friend-morning-v1.png?url";
import chapterSixCompass from "../../../../assets/story/chapters/chapter-06/stills/compass-alone-v1.png?url";
import chapterSixOuterWindow from "../../../../assets/story/chapters/chapter-06/stills/outer-window-v1.png?url";

const backdrops: Readonly<Record<string, string>> = {
  backstage,
  ballReturnStill,
  dreamStreet,
  loopingWalkStill,
  morningBedroom,
  morningStill,
  nightEyes,
  theater,
  walkingHomeStill,
  hospitalRoom,
  outerWindow,
  projectionRoom,
  selectionTable,
  chapterTwoMountain,
  chapterTwoSummit,
  chapterTwoFlight,
  chapterTwoMorning,
  chapterThreeCorridor,
  chapterThreeField,
  chapterThreeFireplace,
  chapterThreeMorningRoom,
  chapterThreeNightmare,
  chapterThreeCocoa,
  chapterThreeMorning,
  chapterFourField,
  chapterFourCafe,
  chapterFourPiano,
  chapterFourAfternoon,
  chapterFourRealizes,
  chapterFourHospital,
  chapterFiveField,
  chapterFiveDining,
  chapterFiveStain,
  chapterFiveLayered,
  chapterFiveCups,
  chapterFiveMorning,
  chapterSixMusicRoom,
  chapterSixRainyRoom,
  chapterSixField,
  chapterSixPianoMorning,
  chapterSixWhatHappened,
  chapterSixFreeze,
  chapterSixFall,
  chapterSixWaiting,
  chapterSixRescue,
  chapterSixSeventhNote,
  chapterSixBackstage,
  chapterSixFriendMorning,
  chapterSixCompass,
  chapterSixOuterWindow,
};

const portraits: Readonly<Record<string, string>> = {
  dog,
  flint,
  manager,
  man,
  protagonist,
  ewer,
  frame,
  pin,
  projector,
  chapterTwoBoy,
  chapterTwoGirl,
  chapterThreeChild,
  chapterThreeSanta,
  chapterFourFriend,
  chapterFourMemoryHeroine,
  chapterFiveOwner,
  chapterFiveRobot,
};

const battlefields: Readonly<Record<string, string>> = {
  "chapter-01": chapterOneField,
  "chapter-02": chapterTwoMountain,
  "chapter-03": chapterThreeField,
  "chapter-04": chapterFourField,
  "chapter-05": chapterFiveField,
  "chapter-06": chapterSixField,
};

export function getStoryBackdropUrl(imageId: string): string {
  return backdrops[imageId] ?? "";
}

export function getStoryPortraitUrl(portraitId: string): string {
  return portraits[portraitId] ?? "";
}

export function getStoryBattlefieldUrl(chapterId: string | undefined): string {
  return chapterId ? battlefields[chapterId] ?? "" : "";
}
